import { createContext } from "react";

import type { TaxDetailsContextType } from "./TaxDetails.types";

const TaxDetailsContext = createContext<TaxDetailsContextType | null>(null);

export { TaxDetailsContext };
